import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';

const reputationItems = [
  {
    name: '张先生',
    location: '北京',
    text: '男同网让我认识了很多志同道合的朋友，这里的氛围真的很好，大家都非常友善和尊重彼此。感谢这个平台让我不再感到孤单。',
    rating: 5,
  },
  {
    name: '李先生',
    location: '上海',
    text: '使用男同网半年了，最欣赏的是平台对隐私保护的重视。实名但不公开的策略让我可以放心地展示真实的自己，不必担心信息泄露。',
    rating: 5,
  },
  {
    name: '王先生',
    location: '成都',
    text: '通过男同网参加了好几次线下活动，体验都非常棒！活动组织专业，参与者的素质也很高。现在我已经找到了固定的一圈好友。',
    rating: 5,
  },
  {
    name: '刘先生',
    location: '深圳',
    text: '作为一个刚出柜不久的人，男同网给了我很大的支持。这里的文章和社群讨论让我意识到自己并不孤单，有很多人和我有着相似的经历和感受。',
    rating: 5,
  },
  {
    name: '陈先生',
    location: '广州',
    text: '在男同网找到了我现在的伴侣，我们在一起快一年了。平台上的交友功能真的很用心，推荐算法也很准确，帮我筛选出了真正合适的人。',
    rating: 5,
  },
  {
    name: '周先生',
    location: '杭州',
    text: '我觉得男同网最棒的是内容质量。每天更新的文章和话题讨论都很有深度，不只是表面的娱乐内容，而是真正能帮助大家成长和思考的。',
    rating: 5,
  },
];

const teamValues = [
  {
    icon: 'ri-eye-line',
    title: '我们的愿景',
    description: '成为华人世界最有温度的男同社群平台，让每一位成员都能在这里找到归属感、获得力量、活出真我。',
  },
  {
    icon: 'ri-flag-line',
    title: '我们的使命',
    description: '通过技术和服务的力量，为男同群体打造安全、友好、高质量的社交空间，促进社群成员之间的真实连接与相互赋能。',
  },
  {
    icon: 'ri-star-line',
    title: '我们的价值观',
    description: '尊重多元、保护隐私、倡导真诚、追求品质。我们相信每个人都值得被看见、被理解、被善待。',
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<string | null>(null);
  const [formError, setFormError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeyField = form.querySelector<HTMLInputElement>('[name="phone_alt"]');
    if (honeyField && honeyField.value.trim()) {
      setFormStatus('success');
      setFormError(null);
      form.reset();
      return;
    }
    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9sn7utlbrt1qcgaj6c0', {
        method: 'POST',
        body: new URLSearchParams(formData as unknown as Record<string, string>),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      const serverMsg = (parsed?.meta as Record<string, string>)?.message || (parsed?.message as string) || '';
      const code = parsed?.code as string;
      if (response.ok && code === 'OK') {
        setFormStatus('success');
        setFormError(null);
        form.reset();
      } else {
        if (serverMsg && serverMsg.includes('spam')) {
          setFormStatus('success');
          setFormError(null);
          form.reset();
        } else {
          setFormError(serverMsg || '提交失败，请稍后重试');
          setFormStatus('error');
        }
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于男同网 - 品牌介绍与口碑评价',
          description: '男同网是专为男同群体打造的社群交友平台，提供安全、私密、友好的交流空间。了解我们的品牌故事、用户口碑与联系方式。',
          publisher: {
            '@type': 'Organization',
            name: '男同网',
            url: 'https://www.nantongwang.com/',
          },
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': 'https://www.nantongwang.com/about',
          },
        }}
      />
      <ScrollToTop />
      <Navbar />
      <main className="pt-20">
        {/* About Hero */}
        <section className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
            <div className="max-w-3xl">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-6 font-heading">
                关于男同网
              </h1>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                男同网创立于2023年，是专为男同群体打造的综合性社群交友平台。我们汇聚了来自全国各地的同道朋友，致力于创造一个安全、私密且充满温度的交流空间。在这里，你可以分享生活点滴、交流兴趣爱好、结识真诚朋友，找到属于你的社群归属感。
              </p>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {teamValues.map((item, index) => (
                <div key={index} className="text-center p-8 rounded-2xl bg-background-50 border border-background-200/70">
                  <div className="w-14 h-14 flex items-center justify-center mx-auto rounded-xl bg-accent-100 text-accent-600 mb-5">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground-950 mb-3 font-heading">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center font-heading">
                品牌故事
              </h2>
              <div className="space-y-5 text-foreground-600 leading-relaxed">
                <p>
                  男同网的诞生，源于创始团队对同志社群真实需求的深刻洞察。多年来，我们注意到许多同志朋友在日常社交中面临着隐私顾虑、沟通障碍和认同困惑。现有的社交平台要么过于娱乐化，要么安全性不足，难以满足社群对安全、真诚、有深度的社交体验的追求。
                </p>
                <p>
                  于是，我们组建了一支充满热情的团队——包括产品设计师、软件工程师、社区运营专家和心理顾问——共同打造了这个以「安全、真诚、归属」为核心理念的平台。从第一行代码到如今的数万用户，男同网始终坚持用户至上、隐私第一的原则。
                </p>
                <p>
                  我们不仅是一个交友平台，更是一个温暖的社群。在这里，你可以阅读来自同道的真实故事与深度思考，参与丰富多彩的线上讨论和线下活动，在男同网找到属于你的一席之地。我们相信，当每一个人都能自由而安全地做自己时，这个世界会变得更加美好。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section id="reputation" className="py-16 md:py-24 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4 font-heading">
                用户口碑
              </h2>
              <p className="text-foreground-600 leading-relaxed">
                来自各地用户的真实评价，是我们不断进步的最大动力
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {reputationItems.map((item, index) => (
                <div
                  key={index}
                  className="p-6 rounded-2xl bg-background-50 border border-background-200/70"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    &ldquo;{item.text}&rdquo;
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-foreground-800">{item.name}</span>
                    <span className="text-xs text-foreground-500">{item.location}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section id="contact" className="py-16 md:py-24 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4 font-heading">
                  联系我们
                </h2>
                <p className="text-foreground-600 leading-relaxed">
                  有任何问题、建议或合作意向？请通过以下方式与我们联系，我们会在24小时内回复
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-12">
                <div className="text-center p-5 rounded-2xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center mx-auto rounded-lg bg-primary-100 text-primary-600 mb-3">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h4>
                  <p className="text-xs text-foreground-500">support@nantongwang.com</p>
                </div>
                <div className="text-center p-5 rounded-2xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center mx-auto rounded-lg bg-accent-100 text-accent-600 mb-3">
                    <i className="ri-time-line text-lg"></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-950 mb-1">工作时间</h4>
                  <p className="text-xs text-foreground-500">周一至周日 9:00-21:00</p>
                </div>
                <div className="text-center p-5 rounded-2xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center mx-auto rounded-lg bg-secondary-100 text-secondary-600 mb-3">
                    <i className="ri-chat-3-line text-lg"></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-950 mb-1">在线客服</h4>
                  <p className="text-xs text-foreground-500">平台内随时在线咨询</p>
                </div>
              </div>

              <form
                onSubmit={handleSubmit}
                data-readdy-form
                id="contact-form"
                className="space-y-5 p-8 rounded-2xl bg-background-50 border border-background-200/70"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      姓名 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-foreground-800 mb-1.5">
                    主题 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                    placeholder="请简要描述您的问题或建议"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-foreground-800 mb-1.5">
                    留言内容 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors resize-none"
                    placeholder="请详细描述您的问题、建议或合作意向（限500字）"
                  ></textarea>
                  <p className="text-xs text-foreground-500 mt-1">限500字以内</p>
                </div>

                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="antispam-field"
                />

                <button
                  type="submit"
                  className="w-full py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  发送留言
                </button>

                {formStatus === 'success' && (
                  <div className="text-center p-3 rounded-lg bg-accent-100 text-accent-700 text-sm">
                    感谢您的留言！我们会在24小时内回复您。
                  </div>
                )}
                {formStatus === 'error' && formError && (
                  <div className="text-center p-3 rounded-lg bg-red-50 text-red-600 text-sm">
                    {formError}
                  </div>
                )}
              </form>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}